const initializeCollapsiblePlanRows = () => {
  $(".jsPlanTheme tr:first-child").on("click", function () {
    const $parentTbody = $(this).parent();
    const $targetRows = $parentTbody.children("tr:not(:first-child)");
    const $icon = $parentTbody.find(".jsAccordionIcon");

    if ($targetRows.first().is(":hidden")) {
      $targetRows.show();
      $icon.removeClass("isClosing").addClass("isOpen");
    } else {
      $targetRows.hide();
      $icon.removeClass("isOpen").addClass("isClosing");
    }
  });
};
  
export default initializeCollapsiblePlanRows;
  